import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import React from "react";

const FacebookIcon: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
            {props.title && <title>{props.title}</title>}
            <path
                fill="#fff"
                d="M29.38 14.599a14.69 14.69 0 10-16.986 14.6V18.876H8.663v-4.273h3.732v-3.26c0-3.703 2.192-5.749 5.549-5.749 1.102.016 2.2.112 3.289.289v3.635h-1.855a2.13 2.13 0 00-2.394 2.309v2.77h4.075l-.652 4.273h-3.42v10.325A14.758 14.758 0 0029.38 14.599z"
            ></path>
        </svg>
    );
};

export default React.memo(FacebookIcon);
